import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '.';

export interface TypedPrice {
  type: string | null;
  formatted?: string | null;
  amount?: number | null;
}

export interface PriceDetails {
  isEnabled: boolean;
  priceKey: string;
  vehicleType: string;
  label?: string | null;
  shortDisclaimer?: string | null;
  longDisclaimer?: string | null;
  hasTextOverride?: boolean;
  textOverride?: string;
}

export type PriceBreakdownType = {
  regular: PriceDetails;
  dealerDiscount: PriceDetails;
  OEMDiscount: PriceDetails;
  dealerMarkup: PriceDetails;
  nonConditionalBonus: PriceDetails;
  dealerPrice: PriceDetails;
  dealerDocFees: PriceDetails;
  destinationAndHandlingFees: PriceDetails;
  retail: PriceDetails;
  final: PriceDetails;
  usedRetail: PriceDetails;
  usedRegular: PriceDetails;
  usedDealerDiscount: PriceDetails;
  usedOEMDiscount: PriceDetails;
  usedDealerMarkup: PriceDetails;
  usedNonConditionalBonus: PriceDetails;
  usedDealerPrice: PriceDetails;
  usedDealerDocFees: PriceDetails;
  usedDestinationAndHandlingFees: PriceDetails;
  usedFinal: PriceDetails;
};

export type FilteredPriceBreakdownConfig = {
  regular: PriceDetails;
  dealerDiscount: PriceDetails;
  OEMDiscount: PriceDetails;
  dealerMarkup: PriceDetails;
  nonConditionalBonus: PriceDetails;
  dealerPrice: PriceDetails;
  dealerDocFees: PriceDetails;
  destinationAndHandlingFees: PriceDetails;
  retail: PriceDetails;
  final: PriceDetails;
};

export interface PriceBreakdownReducerTypes {
  priceBreakdownGroup: PriceBreakdownType | null;
  displayRebates: boolean | null;
  displayRebatesUsed: boolean | null;
  negativePricesNew: string[];
  negativePricesUsed: string[];
}

const initialState: PriceBreakdownReducerTypes = {
  priceBreakdownGroup: null,
  displayRebates: false,
  displayRebatesUsed: false,
  negativePricesNew: [],
  negativePricesUsed: [],
};

const priceBreakdownsSlice = createSlice({
  name: 'priceBreakdownGroup',
  initialState,
  reducers: {
    setPriceBreakdowns: (_state, action: PayloadAction<PriceBreakdownReducerTypes>) => {
      return {
        priceBreakdownGroup: action.payload.priceBreakdownGroup,
        displayRebates: action.payload.displayRebates,
        displayRebatesUsed: action.payload.displayRebatesUsed,
        negativePricesNew: action.payload.negativePricesNew,
        negativePricesUsed: action.payload.negativePricesUsed,
      };
    },
  },
});

export const selectPriceBreakdowns = (state: RootState) => state.priceBreakdownGroup;

export const { setPriceBreakdowns } = priceBreakdownsSlice.actions;

export default priceBreakdownsSlice.reducer;
